import { LazyQueryHookOptions, MutationHookOptions, useMutation } from '@apollo/react-hooks';
import { QueryHookOptions, useLazyQuery, useQuery } from 'react-apollo';

import {
  CancelCompanyLicense,
  CancelCompanyLicenseVariables,
  CreateCompany,
  CreateCompanyLicense,
  CreateCompanyLicenseVariables,
  CreateCompanyVariables,
  GetCompany,
  GetCompanyLicenses,
  GetCompanyLicensesVariables,
  GetCompanyOffers,
  GetCompanyOffersVariables,
  GetCompanyVariables,
  UpdateCompany,
  UpdateCompanyVariables,
} from './__queries__';
import {
  CancelCompanyLicenseDocument,
  CreateCompanyDocument,
  CreateCompanyLicenseDocument,
  GetCompanyDocument,
  GetCompanyLicensesDocument,
  GetCompanyOffersDocument,
  UpdateCompanyDocument,
} from './document';

export const useGetCompanyOffersQuery = (
  options?: QueryHookOptions<GetCompanyOffers, GetCompanyOffersVariables>,
) =>
  useQuery<GetCompanyOffers, GetCompanyOffersVariables>(GetCompanyOffersDocument, {
    fetchPolicy: 'network-only',
    ...options,
  });

export const useGetCompanyOffersOffersLazyQuery = (
  options?: LazyQueryHookOptions<GetCompanyOffers, GetCompanyOffersVariables>,
) =>
  useLazyQuery<GetCompanyOffers, GetCompanyOffersVariables>(GetCompanyOffersDocument, {
    fetchPolicy: 'network-only',
    ...options,
  });

export const useGetCompanyLicensesQuery = (
  options?: QueryHookOptions<GetCompanyLicenses, GetCompanyLicensesVariables>,
) =>
  useQuery<GetCompanyLicenses, GetCompanyLicensesVariables>(GetCompanyLicensesDocument, {
    fetchPolicy: 'network-only',
    ...options,
  });

export const useCreateCompanyLicenseMutation = (
  options?: MutationHookOptions<CreateCompanyLicense, CreateCompanyLicenseVariables>,
) =>
  useMutation<CreateCompanyLicense, CreateCompanyLicenseVariables>(CreateCompanyLicenseDocument, {
    ...options,
  });

export const useCancelCompanyLicenseMutation = (
  options?: MutationHookOptions<CancelCompanyLicense, CancelCompanyLicenseVariables>,
) =>
  useMutation<CancelCompanyLicense, CancelCompanyLicenseVariables>(CancelCompanyLicenseDocument, {
    ...options,
  });

export const useGetCompanyQuery = (options?: QueryHookOptions<GetCompany, GetCompanyVariables>) =>
  useQuery<GetCompany, GetCompanyVariables>(GetCompanyDocument, {
    fetchPolicy: 'network-only',
    ...options,
  });

export const useGetCompanyLazyQuery = (
  options?: LazyQueryHookOptions<GetCompany, GetCompanyVariables>,
) =>
  useLazyQuery<GetCompany, GetCompanyVariables>(GetCompanyDocument, {
    fetchPolicy: 'network-only',
    ...options,
  });

export const useCreateCompanyMutation = (
  options?: MutationHookOptions<CreateCompany, CreateCompanyVariables>,
) =>
  useMutation<CreateCompany, CreateCompanyVariables>(CreateCompanyDocument, {
    ...options,
  });

export const useUpdateCompanyMutation = (
  options?: MutationHookOptions<UpdateCompany, UpdateCompanyVariables>,
) =>
  useMutation<UpdateCompany, UpdateCompanyVariables>(UpdateCompanyDocument, {
    ...options,
  });
